module.exports = __webpack_public_path__ + "static/media/Step3Tutorial-2.5b488ebf.png";